import styles from "./AscCalendarDayView.module.scss";
import classNames from "classnames";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import { useMemo } from "react";
import { CalendarDate } from "../../../lib/helpers/hooks/useCalendarDays";
dayjs.extend(isToday);

interface AscCalendarDayViewProps {
  dayLabel: string;
  date: Date;
  activeMonth: boolean;
  onDayClick?: (day: CalendarDate) => void;
  selected?: boolean;
  maxSelected?: boolean;
}
export default function AscCalendarDayView({
  dayLabel,
  date,
  activeMonth,
  selected,
  onDayClick,
  maxSelected,
}: AscCalendarDayViewProps) {
  const isToday = useMemo(() => dayjs(date).isToday(), [date]);
  const isPast = useMemo(() => dayjs(date).isBefore(dayjs()), [date]);

  if (!dayLabel) {
    return <div />;
  }

  function handleClick() {
    onDayClick?.({
      date,
      dayLabel,
    });
  }

  return (
    <button
      data-testid={`asc-calendar-day-view-${dayjs(date)?.format("MM-DD-YYYY")}`}
      className={classNames(styles.ground, {
        [styles.isToday]: isToday,
        [styles.activeMonth]: activeMonth,
        [styles.selected]: selected,
        [styles.disabled]: isPast || (!selected && maxSelected),
      })}
      type="button"
      onClick={handleClick}
      disabled={isPast || (!selected && maxSelected)}
    >
      {dayLabel?.toLocaleString()}
    </button>
  );
}
